/**
 * Enum for form steps
 */
export enum FORM_STEPS {
    DEAL_SOW = 1,
    PROJECT_DETAILS,
    ACCOUNT_N_LOCATION,
    CHARGER_DETAILS,
    MATERIAL_DISPATCH,
    SURVEY,
    INFRA,
    SAAS,
    PAYMENT_DETAILS,
    SPOC_DETAILS,
}

/**
 * Enum for scope of work
 */
export enum SCOPE_OF_WORK {
    CHARGER = 1,
    SAAS,
    INFRA,
    SOLO_SURVEY,
    SOLO_LOGISTICS,
    DEMOLITION,
}

/**
 * Enum for deal templates
 */
export enum DEAL_TEMPLATES {
    CHARGER_DELIVERY = 1,
    CHARGER_INFRA, 
    CHARGER_INFRA_SAAS,
    // CHARGER_SOLO_LOGISTICS,
    // CHARGER_SOLO_SURVEY,
    INFRA_SAAS,
    INFRA,
    SOLO_SURVEY,
    SOLO_LOGISTICS,
    DEMOLITION,
    EV_INFRA,
}

export enum DEAL_TYPE {
    CPO = "CPO",
    OUTRIGHT = "Outright",
}

/**
 * Options for scope of work
 *
 */
export const SCOPE_OF_WORK_OPTIONS = [
    { id: SCOPE_OF_WORK.CHARGER, title: "Charger" },
    { id: SCOPE_OF_WORK.SAAS, title: "SaaS" },
    { id: SCOPE_OF_WORK.INFRA, title: "Infra (EPC)" },
    { id: SCOPE_OF_WORK.SOLO_SURVEY, title: "Solo Survey" },
    { id: SCOPE_OF_WORK.SOLO_LOGISTICS, title: "Solo Logistics" },
    { id: SCOPE_OF_WORK.DEMOLITION, title: "Dismantle" },
]

/**
 * Options for deal templates
 *
 */
export const DEAL_TEMPLATES_OPTIONS = [
    { id: DEAL_TEMPLATES.CHARGER_DELIVERY, title: "Charger Delivery" },
    { id: DEAL_TEMPLATES.CHARGER_INFRA, title: "Charger Delivery + Infra" },
    { id: DEAL_TEMPLATES.CHARGER_INFRA_SAAS, title: "Charger Delivery + Infra + SaaS" },
    // { id: DEAL_TEMPLATES.CHARGER_SOLO_SURVEY, title: "Charger Delivery + Solo Survey" },
    // { id: DEAL_TEMPLATES.CHARGER_SOLO_LOGISTICS, title: "Charger Delivery + Solo Logistics" },
    { id: DEAL_TEMPLATES.INFRA_SAAS, title: "Infra + SaaS" },
    { id: DEAL_TEMPLATES.INFRA, title: "Infra" },
    { id: DEAL_TEMPLATES.SOLO_SURVEY, title: "Solo Survey" },
    { id: DEAL_TEMPLATES.SOLO_LOGISTICS, title: "Solo Logistics" },
    { id: DEAL_TEMPLATES.DEMOLITION, title: "Demolition" },
    { id: DEAL_TEMPLATES.EV_INFRA, title: "EV Infra" },
]

export const DEAL_TYPE_OPTIONS = [
    { id: 0, title: DEAL_TYPE.CPO },
    { id: 1, title: DEAL_TYPE.OUTRIGHT },
]

/**
 * Base steps common to all deal templates
 *
 */
export const BASE_STEPS: FORM_STEPS[] = [
    FORM_STEPS.DEAL_SOW,
    FORM_STEPS.PROJECT_DETAILS,
    FORM_STEPS.ACCOUNT_N_LOCATION,
    FORM_STEPS.CHARGER_DETAILS,
]
